module.exports = __webpack_public_path__ + "static/media/_L1-CSharp.50bf30d3.svg";